// src/components/common/SelectDropdown.tsx
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export interface SelectOption {
  label: string;
  value: string;
}

interface SelectDropdownProps {
  value?: string;
  options: SelectOption[];
  placeholder?: string;
  onChange: (value: string) => void;

  triggerClassName?: string;
  contentClassName?: string;
  disabled?: boolean;
}

const SelectDropdown = ({
  value,
  options,
  placeholder = 'Select',
  onChange,
  triggerClassName,
  contentClassName,
  disabled = false,
}: SelectDropdownProps) => {
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className={triggerClassName}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>

      <SelectContent className={contentClassName}>
        {options.map((opt) => (
          <SelectItem key={opt.value} value={opt.value}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default SelectDropdown;
